var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleteProfileArt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 390,
    height: 600,
    viewBox: "0 0 390 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "jj2w5uti0a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4A65A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0D152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a4rs0xye5b",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5B5AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E77E75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "grpoluo0xc",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5B5AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E77E75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0fu1zrkb2d",
    x1: "26.419%",
    x2: "73.581%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFCFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FB7932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chvqn14mue",
    x1: "20.251%",
    x2: "79.749%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFCFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FB7932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gbr6dilzdf",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E77E75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F5B5AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u2nur4awpg",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5B5AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E77E75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qsvclq8j7h",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5B5AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E77E75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dpimsoftri",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4A65A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0D152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7uskqyvd6j",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4A65A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0D152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mdui356i2k",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4A65A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0D152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j0he5yux0l",
    x1: "24.148%",
    x2: "75.852%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFCFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FB7932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at56hlmhom",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4A65A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0D152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r8a6bc9iln",
    x1: "106.279%",
    x2: "1.255%",
    y1: "108.034%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#29CC8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#79F6D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prfdai757o",
    x1: "50.065%",
    x2: "49.944%",
    y1: "108.034%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#29CC8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#79F6D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e6dk8vd2dp",
    x1: "50.383%",
    x2: "49.668%",
    y1: "108.034%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#29CC8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#79F6D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c8ocupwz8q",
    x1: "53.646%",
    x2: "46.842%",
    y1: "108.034%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#29CC8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#79F6D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "84c8j2gc5r",
    x1: "33.746%",
    x2: "66.254%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFCFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FB7932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fp5736jvvs",
    x1: "112.711%",
    x2: "-4.316%",
    y1: "65.343%",
    y2: "36.781%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#29CC8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#79F6D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9hic7l4h5t",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4A65A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0D152B"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#jj2w5uti0a)",
    d: "M166.94 137.233c.09-3.634 3.453-8.416 16.976-9.277 13.525-.86 18.55-.234 24.14 10.329 6.024 11.387 12.91 24.099 8.415 35.767-4.494 11.667-18.65 18.508-28.785 24.672-10.135 6.166-25.247 26.873-25.247 26.873s-28.198-78.132 4.501-88.364"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0E5FA",
    d: "M389.831 580.333c0 10.765-87.2 19.491-194.767 19.491S.297 591.098.297 580.333c0-10.766 87.2-19.493 194.767-19.493 107.568 0 194.767 8.727 194.767 19.493",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a4rs0xye5b)",
    d: "M168.477 269.118s20.507 105.257 27.778 148.037c7.563 44.5 13.934 140.244 13.934 140.244h11.389s14.51-82.526-.017-143.987c.976-48.988-8.545-150.884-8.545-150.884l-44.54 6.59"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#grpoluo0xc)",
    d: "M183.413 266.91s44.973 110.06 60.632 150.53c21.955 29.433 77.168 91.877 80.19 93.122l4.003-8.998s-33.739-65.977-60.942-98.585c-7.233-48.46-41.662-142.317-41.662-142.317l-42.22 6.247"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E77E75",
    d: "M166.888 224.683c-3.243 3.787-6.567 7.412-9.884 11.087-3.337 3.65-6.75 7.231-10.17 10.815-3.413 3.591-6.882 7.134-10.466 10.595-3.57 3.478-7.178 6.929-10.955 10.318l.57-.606c-.876 1.021-1.847 1.796-2.788 2.393-.921.554-1.85 1.002-2.686 1.293-1.707.625-3.222.895-4.653 1.059-2.852.313-5.388.216-7.853.025-4.909-.406-9.477-1.342-13.977-2.4-4.483-1.118-8.86-2.402-13.188-3.791-4.32-1.457-8.55-2.958-12.798-4.741-1.84-.775-2.704-2.894-1.931-4.736.683-1.621 2.411-2.487 4.072-2.138l.07.016c4.251.888 8.6 1.802 12.906 2.568 4.302.827 8.61 1.54 12.885 2.07 4.257.57 8.52.96 12.514.982 1.981.007 3.921-.11 5.483-.425.77-.153 1.447-.358 1.82-.539.214-.084.271-.168.304-.184-.012-.019-.126.033-.277.208l.57-.607c3.38-3.35 6.711-6.865 10.011-10.416l9.876-10.754 19.637-21.717c2.694-2.978 7.294-3.21 10.273-.516 2.927 2.647 3.202 7.135.654 10.116l-.019.025"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E77E75",
    d: "M73.077 254.82l-7.189-12.44-4.913 13.608s6.032 6.861 11.79 5.515l.312-6.683M56.944 242.748l-1.747 5.805c-.4 1.325.041 2.761 1.113 3.635l4.665 3.8 4.913-13.608-4.364-1.806c-1.869-.773-3.998.236-4.58 2.174"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#0fu1zrkb2d)",
    d: "M167.03 207.312c-10.12-1.652-14.61 5.345-19.437 10.662 1.147 9.397 17.729 28.682 17.729 28.682s20.097-36.342 1.708-39.344"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#chvqn14mue)",
    d: "M153.567 218.86c1.286 10.234 6.174 38.976 19.87 82.01l59.747-8.838c-4.124-21.666-9.826-42.13-7.192-85.252.306-5.023-3.694-9.263-8.727-9.244-4.044.016-9.034.181-14.23.696-9.687.957-17.612 1.816-25.954 3.838-5.514 1.338-11.344 3.126-15.789 4.576-5.174 1.689-8.404 6.811-7.725 12.213"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M177.08 202.07l25.954-3.838s-1.18 9.96-17.534 23.061c-12.432-11.53-8.42-19.223-8.42-19.223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gbr6dilzdf)",
    d: "M196.14 169.388c-.401 8.592.229 24.134 6.896 28.844 0 0-5.194 9.504-16.751 16.65-9.068-3.95-9.204-12.812-9.204-12.812 8.984-3.6 7.722-10.474 5.14-16.723l13.919-15.959"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#09181B",
    d: "M183.708 189.828l-.084-.367.087.365-.003.002m-1.482-4.488v-.001l2.301-2.638-2.301 2.64"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#u2nur4awpg)",
    d: "M183.711 189.826l-.087-.365c-.336-1.377-.832-2.764-1.398-4.12l2.301-2.64 5.94-6.802c.43.82.772 2.594.858 4.479.174 3.78-4.133 8.407-7.614 9.448"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#qsvclq8j7h)",
    d: "M202.681 152.765c-1.265 14.064-1.501 20.042-8.82 27.07-11.012 10.573-28.007 5.943-30.97-8.214-2.664-12.743-.148-33.6 13.8-38.812 13.744-5.138 27.255 5.896 25.99 19.956"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dpimsoftri)",
    d: "M191.893 141.824c-1.243 8.416 3.73 18.716 8.034 18.827 4.303.108 7.555-16.15 7.555-16.15l-15.589-2.677"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#7uskqyvd6j)",
    d: "M167.987 137.52c9.18 6.502 36.434 16.257 37.01 7.841.573-8.416-10.807-15.205-19.223-15.205-8.416 0-15.205 3.347-17.787 7.364"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BEBFBB",
    d: "M198.672 428.485c-.334-1.897-.682-3.859-1.043-5.876.363 2.017.714 3.972 1.052 5.873l-.009.003m27.392-13.716c-.043-1.752-.093-3.53-.15-5.332h.004c.055 1.8.105 3.58.146 5.332"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB6E60",
    d: "M198.68 428.482c-.337-1.9-.688-3.856-1.051-5.873-.265-1.484-.539-2.997-.818-4.538l29.104-8.634c.056 1.802.106 3.58.15 5.332.023.971.046 1.932.065 2.885l-27.45 10.828"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BEBFBB",
    d: "M237.525 413.167l-.298-.747.298.747m29.295-11.554c-.319-1.327-.648-2.672-.981-4.02l.001-.001c.336 1.351.665 2.69.983 4.02h-.003"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB6E60",
    d: "M237.525 413.167l-.298-.747c-.738-1.858-1.492-3.748-2.26-5.669l30.872-9.158c.333 1.348.662 2.693.98 4.02l-29.294 11.554"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#132529",
    d: "M182.074 156.47c-.032 1.146-.666 2.058-1.416 2.036-.749-.02-1.33-.968-1.298-2.114.033-1.147.666-2.059 1.417-2.04.748.022 1.33.97 1.297 2.117M169.11 156.101c-.032 1.146-.667 2.059-1.416 2.038-.75-.022-1.332-.969-1.3-2.115.033-1.149.668-2.061 1.417-2.04.75.022 1.332.969 1.3 2.117"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#132529",
    d: "M168.142 154.056l-2.734-.871s1.353 2.191 2.734.871"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E15B5A",
    d: "M172.481 158.168s-2.088 4.884-4.298 7.206c1.475 1.455 4.068.881 4.068.881l.23-8.087"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#132529",
    d: "M176.316 170.538c-.599.088-1.24.131-1.93.11-.185-.005-.331-.16-.326-.346.007-.184.156-.33.347-.327 5.03.147 7.485-3.305 7.51-3.34l.467-.087.086.47c-.093.134-2.067 2.914-6.154 3.52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E77E75",
    d: "M205.726 160.227c-.695 2.844-2.639 5.1-4.715 6.314-3.122 1.828-5.6-.743-5.5-4.169.092-3.085 1.827-7.753 5.33-8.182 3.451-.423 5.68 2.787 4.885 6.037"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#132529",
    d: "M186.884 150.553c-.179.01-.36-.048-.5-.179-2.194-2.055-4.61-1.492-4.637-1.487-.358.082-.726-.135-.814-.494-.09-.364.131-.727.494-.816.126-.031 3.155-.739 5.877 1.814.272.253.286.68.031.95-.122.131-.286.203-.451.212M165.714 149.463c-.163-.032-.315-.127-.418-.275-.21-.306-.132-.726.172-.936 3.07-2.118 5.961-.97 6.084-.92.344.143.51.536.366.88-.14.344-.532.508-.876.37-.113-.046-2.368-.905-4.808.778-.158.109-.346.141-.52.103M181.105 154.426l-2.732-.873s1.353 2.193 2.732.873"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#mdui356i2k)",
    d: "M173.437 300.87l19.997 118.205 74.827-22.201c-6.117-62.459-21.647-93.407-35.077-104.842l-59.747 8.839"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E77E75",
    d: "M225.242 203.477c1.268 1.134 2.836 2.442 4.29 3.658 1.488 1.23 3.006 2.434 4.549 3.6 3.083 2.335 6.19 4.628 9.41 6.69 6.416 4.107 13.147 7.696 19.877 9.554.422.132.835.205 1.254.311l.626.152c.12.027.083.02.024.012-.033-.005-.07-.01-.09-.009h-.24c-.7.042-.956.307-.765.228.407-.142 1.57-1.217 2.496-2.514 1.946-2.663 3.782-6.074 5.41-9.558 1.679-3.493 3.232-7.146 4.667-10.859 1.474-3.69 2.88-7.498 4.23-11.208l.034-.095c.684-1.876 2.76-2.843 4.636-2.16 1.633.594 2.577 2.243 2.346 3.897-1.164 8.335-2.986 16.374-5.61 24.532-1.404 4.059-2.916 8.116-5.427 12.277-1.328 2.069-2.722 4.276-5.698 6.436-1.496 1.031-3.72 2.109-6.47 2.11-.335.01-.669-.015-1.003-.048-.304-.026-.762-.084-.82-.1l-.872-.146c-.576-.107-1.17-.184-1.731-.317-4.583-.924-8.855-2.432-12.923-4.195-4.064-1.768-7.903-3.849-11.59-6.097-3.68-2.257-7.25-4.632-10.647-7.221-1.7-1.295-3.37-2.624-5.016-3.99-1.678-1.384-3.202-2.722-4.921-4.352-2.914-2.766-3.035-7.367-.27-10.282 2.712-2.857 7.193-3.03 10.113-.423l.13.117"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j0he5yux0l)",
    d: "M216.616 197.536c10.235-.604 14.248 4.775 18.505 10.561-2.106 9.227-13.295 25.007-13.295 25.007s-23.812-34.468-5.21-35.568"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E77E75",
    d: "M280.515 194.364l2.586-15.15 9.335 11.053s-3.271 8.53-9.14 9.268l-2.781-5.171"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E77E75",
    d: "M291.635 175.093l5.614 4.92c1.027.898 1.21 2.43.421 3.544l-6.224 8.807-8.345-13.15 5.083-4.174c1.008-.83 2.47-.806 3.451.053"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#132529",
    d: "M188.562 578.944c1.429-1.198 3.723-2.188 5.751-2.903h-.005s10.196-5.756 15.503-23.064l11.782-2.946c1.245-.311 2.484.532 2.636 1.806.112.935.179 1.997.3 2.861.22 1.604.025 4.037-.002 5.626-.1 5.85-.754 18.998-.754 18.998h-1.369s-.043-8.083-.724-11.936c-.68-3.852-3.402.71-4.927 5.068-1.527 4.359-7.653 9.01-16.561 9.227-10.432.253-14.66-.205-11.63-2.737M320.013 538.32c.162-1.858 1.081-4.182 2.006-6.122l-.004.003s3.126-11.282-5.382-27.263l6.233-10.423c.659-1.101 2.13-1.382 3.14-.592.74.58 1.54 1.282 2.237 1.81 1.293.975 2.878 2.83 3.984 3.972 4.07 4.204 12.92 13.95 12.92 13.95l-.965.97s-5.757-5.678-8.965-7.916c-3.21-2.24-1.9 2.908.11 7.067 2.009 4.159.974 11.78-5.164 18.241-7.185 7.564-10.494 10.236-10.15 6.302"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M264.103 366.1c-6.663-37.551-17.229-59.492-27.232-70.478h36.82l-5.907 61.667c-.315 3.281-1.6 6.324-3.68 8.812m-32.941-84.277c-1.484-7.423-2.971-15.135-4.073-24.075l.002-.013c.046-.492-.017-.969-.172-1.406-.96-8.21-1.589-17.47-1.598-28.461.713-1.116 1.491-2.359 2.288-3.684 1.167.838 2.353 1.654 3.553 2.453v55.186"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFD",
    d: "M274.516 287.024h-42.312c-.342-1.725-.692-3.457-1.041-5.2v-55.186c1.539 1.024 3.104 2.02 4.69 2.99 3.686 2.248 7.525 4.33 11.59 6.097.147.064.295.128.445.191V270.3h28.23l-1.602 16.725"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFD",
    d: "M273.691 295.622h-36.82c-1.241-1.363-2.472-2.556-3.687-3.59l-.251.036.25-.036c-.318-1.674-.645-3.34-.979-5.008h42.312l-.825 8.598"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M276.119 270.3h-26.107v-33.51c3.291 1.302 6.726 2.399 10.353 3.13.56.133 1.155.21 1.731.317l.871.146c.059.016.517.074.821.1.283.028.567.05.849.05.052 0 .102 0 .153-.002.653 0 1.274-.062 1.864-.167l10.148 22.805-.683 7.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M276.802 263.17l-10.148-22.806c1.9-.342 3.466-1.156 4.607-1.943 2.976-2.16 4.37-4.367 5.698-6.436 1.444-2.393 2.558-4.753 3.511-7.098l-3.668 38.282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDFCFA",
    d: "M250.012 270.3h-2.124v-34.384c.702.301 1.41.592 2.124.875v33.508"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M184.386 365.6l-1.852-.177v-10.778l1.852 10.955m-2.282-.219l-57.269-5.486v-22.588l17.457 1.672.425-4.42-17.882-1.714v-5.575l10.676 1.022.424-4.42-11.1-1.064v-5.575l30.197 2.893.423-4.42-30.62-2.935V279.03l43.215 4.142c1.624 5.594 3.412 11.497 5.387 17.699l1.15-.17-1.15.17 8.667 51.23v13.28m-17.582-94.834l-38.408-3.68c3.243-2.932 6.366-5.91 9.454-8.908l26.342 2.523c.8 3.202 1.67 6.557 2.612 10.065m-5.597-22.636l-12.235-1.172.144-.154c3.245-3.398 6.48-6.796 9.652-10.249.68 3.467 1.487 7.33 2.44 11.575"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFD",
    d: "M182.534 365.423L182.104 365.381 182.104 352.101 182.534 354.645 182.534 365.423"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M128.77 245.02l-3.935-.376v-45.71c5.844 9.285 13.974 16.827 23.478 21.968.205.594.446 1.21.718 1.842l-12.688 14.031-7.573 8.246"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFD",
    d: "M124.835 359.895l-4.448-.427V336.88l4.448.427v22.588m0-27.05l-4.448-.426v-5.576l4.448.427v5.575m0-10.037l-4.448-.425v-5.576l4.448.426v5.575m0-10.037l-4.448-.425v-33.979c.362.188.766.31 1.196.351l3.252.312v33.74m0-68.126l-4.448-.426v-52.837l.28-.231c1.216 2.711 2.61 5.309 4.168 7.784v45.71"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M120.387 359.468l-11.676-1.119v-22.588l11.676 1.12v22.587m0-27.05l-11.676-1.118v-15.612l11.676 1.12v5.575l-6.226-.597-.424 4.42 6.65.637v5.576m0-20.073l-11.676-1.12v-39.512c1.088.074 2.195.126 3.341.126 1.215 0 2.475-.057 3.804-.203 1.002-.114 2.045-.281 3.166-.586l-.39 4.089c-.133 1.373.602 2.628 1.755 3.227v33.979m-11.667-52.852h-.01v-58.479l11.677-9.634v52.837l-3.968-.38c-.105-.01-.211-.015-.316-.015-1.67 0-3.099 1.27-3.26 2.967l-.543 5.643c-.172 1.804 1.15 3.405 2.954 3.579l2.86.273c-.552.558-1.104 1.11-1.659 1.66l-.485.518c-.01.008-.02.019-.031.03l-.08.035c-.373.181-1.05.386-1.82.54-1.52.305-3.397.426-5.32.426m7.223-1.002l.028-.03c.091-.087.158-.123.184-.123.004 0 .007.002.009.005-.028.014-.073.078-.22.148"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFD",
    d: "M108.71 358.35l-40.118-3.844c-4.296-.412-8.186-2.486-10.953-5.84-2.768-3.353-4.064-7.565-3.652-11.861l7.675-80.101c1.412 1.397 4.823 4.4 8.518 4.902 3.53 1.41 7.062 2.653 10.658 3.865 4.328 1.389 8.705 2.673 13.188 3.79 4.5 1.059 9.068 1.995 13.977 2.401.236.018.472.037.708.052v39.513l-26.685-2.557-.425 4.42 27.11 2.598V331.3l-28.592-2.74-.424 4.421 29.016 2.78v22.588m-27.639-39.734l-.423 4.42 27.002 2.59.423-4.423-27.002-2.587m27.639-59.121c-.052 0-.103 0-.155-.002-3.994-.022-8.257-.413-12.514-.983-4.275-.528-8.583-1.242-12.885-2.069-3.434-.61-6.896-1.315-10.314-2.028l-6.955-12.032-2.745-1.136.273-2.856 45.295-37.373v58.479"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDECE8",
    d: "M112.052 271.84c-1.146 0-2.253-.052-3.341-.126-.236-.015-.472-.034-.708-.052-4.909-.406-9.477-1.342-13.977-2.4-4.483-1.118-8.86-2.402-13.188-3.791-3.596-1.212-7.128-2.455-10.658-3.865.346.047.693.072 1.041.072.515 0 1.031-.055 1.544-.175l.312-6.683-.234-.408c3.418.713 6.88 1.417 10.314 2.028 4.302.827 8.61 1.54 12.885 2.07 4.257.57 8.52.96 12.514.982.052.002.103.002.155.002h.009c1.922 0 3.799-.12 5.319-.427.77-.153 1.447-.358 1.82-.539.028-.012.056-.024.08-.036l-.053.06.056-.06c.148-.07.193-.134.22-.148 0-.003-.004-.005-.008-.005-.026 0-.093.036-.184.124l.485-.518c.555-.55 1.107-1.102 1.658-1.66l17.455 1.674c-3.088 2.998-6.21 5.976-9.454 8.908l-3.363-.322c-.107-.01-.214-.016-.319-.016-1.67 0-3.098 1.27-3.26 2.968l-.15 1.554c-1.12.305-2.164.472-3.166.586-1.329.146-2.589.203-3.804.203m34.638-25.101l-17.92-1.718 7.573-8.246 12.688-14.03c1.633 3.791 4.386 8.165 7.17 12.126.092.48.187.968.285 1.465-3.172 3.453-6.407 6.851-9.652 10.25-.048.051-.096.1-.144.153"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDECE8",
    d: "M71.221 261.678c-.348 0-.695-.025-1.041-.072-3.695-.503-7.106-3.505-8.518-4.902l.341-3.562 3.885-10.762 6.955 12.032.234.408-.312 6.683c-.513.12-1.03.175-1.544.175M62.003 253.142L63.143 241.244 65.888 242.38 62.003 253.142"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2ECF2",
    d: "M156.2 234.871c-2.783-3.96-5.536-8.335-7.17-12.127-.271-.632-.512-1.248-.717-1.842 1.926 1.042 3.91 1.985 5.942 2.825.462 3 1.097 6.727 1.945 11.144"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2E9E2",
    d: "M173.437 300.87c-1.975-6.201-3.763-12.104-5.387-17.698l44.395 4.253c.106.01.213.016.318.016 1.67 0 3.099-1.273 3.26-2.97l.543-5.64c.172-1.805-1.15-3.407-2.954-3.58l-49.09-4.704c-.942-3.508-1.811-6.863-2.612-10.065l61.063 5.851c.105.01.21.016.315.016 1.671 0 3.1-1.27 3.263-2.97l.54-5.63c1.1 8.94 2.588 16.652 4.072 24.075.35 1.743.699 3.475 1.041 5.2.334 1.668.661 3.334.98 5.008l-.251.036-58.347 8.632-1.15.17m53.484-44.54c-.413-1.165-1.47-2.047-2.782-2.17l-65.213-6.25c-.952-4.244-1.759-8.107-2.439-11.574l-.286-1.465c-.848-4.417-1.483-8.143-1.945-11.144 5.677 2.346 11.738 3.878 18.016 4.48 2.054.197 4.1.295 6.137.295 12.44 0 24.466-3.644 34.81-10.541 3.627 7.932 8.608 15.143 8.608 15.143s1.496-2.11 3.496-5.235c.009 10.99.637 20.25 1.598 28.461"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M264.126 227.688c-.045 0 .062-.093.32-.165-.109.076-.2.125-.269.15-.024.01-.04.015-.051.015M208.656 110.018c-1.761-.97-3.567-1.85-5.407-2.64v-9.513l5.407 12.153m-5.837-2.823c-.79-.33-1.586-.646-2.388-.943-.377-.142-.755-.28-1.134-.414l-16.763-20.317v-26.77l3.46.333 16.825 37.814v10.297m-20.715-22.196l-23.556-28.545 23.556 2.256V85m49.059-2.51l-8.867-19.927 5.8.554-.89 9.535h3.957v9.838"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFD",
    d: "M182.534 85.521L182.104 84.999 182.104 58.71 182.534 58.752 182.534 85.521M203.25 107.377l-.431-.182V96.898l.43.967v9.512M247.888 220.117c-1.479-.86-2.947-1.762-4.396-2.692-3.147-2.016-6.187-4.252-9.203-6.53.274-.775.51-1.526.694-2.24h12.905v11.462m-2.672-27.934h-9.743c1.606-3.434 2.904-7.022 3.872-10.728h1.098l4.773 10.728m2.672-108.803h-16.329l-.396-.89v-9.838h14.883l.162.336c.329.683.978 1.106 1.68 1.182v9.21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M260.265 226.003c-3.445-1.21-6.875-2.825-10.253-4.682v-12.666h2.534l7.719 17.348M251.279 83.38h-1.267V73c.055-.112.1-.229.134-.35h14.133l-13 10.729M264.718 227.315l-.096-.025c-.419-.106-.832-.179-1.254-.311-1.034-.286-2.07-.613-3.103-.976l-7.719-17.348h22.636c-.981 2.365-2.012 4.689-3.098 6.946-1.629 3.484-3.465 6.895-5.41 9.558-.65.91-1.416 1.71-1.956 2.156m5.823-35.132h-20.529v-10.728h11.678l8.851 10.728m-22.653 0h-2.672l-4.773-10.728h7.445v10.728m0-27.201h-6.47c-.014-3.002-.243-5.984-.682-8.922l7.152 8.669v.253m-33.347-51.289l-.161-.112c-1.847-1.294-3.758-2.484-5.724-3.563l-22.662-50.934 36.302 3.479 9.263 20.817h-2.814l-1.54 16.473h4.108l-16.772 13.84"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDFCFA",
    d: "M250.012 221.32c-.71-.39-1.418-.791-2.124-1.203v-11.462h2.124v12.666zm-2.124-29.137h2.124v-10.728h-2.124v10.728zm.21-27.201h-.21v-.253l.21.253zm1.914-81.602h-2.124v-9.21c.076.009.151.012.227.012.308 0 .623-.067.92-.21.442-.213.776-.563.977-.97V83.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFD",
    d: "M264.279 72.652h-14.133c.142-.484.109-1.017-.127-1.506l-.007-.014v-5.913l11.733 1.124 2.734 6.145-.2.164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M264.479 72.488L261.745 66.343 270.868 67.216 264.479 72.488M231.163 72.652L227.206 72.652 228.096 63.117 231.163 63.412 231.163 72.652"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFD",
    d: "M246.046 72.652h-14.883v-9.24l10.922 1.046 3.961 8.194m1.842-5.913l-.873-1.807.873.082v1.725"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDFCFA",
    d: "M250.012 71.132L247.888 66.739 247.888 65.014 250.012 65.219 250.012 71.132"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFD",
    d: "M250.012 84.424L250.012 83.38 251.279 83.38 250.012 84.424M236.856 95.281L231.559 83.38 247.888 83.38 247.888 86.177 236.856 95.281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M231.313 99.853L227.206 99.853 228.745 83.38 231.559 83.38 236.856 95.281 231.313 99.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDFCFA",
    d: "M247.888 86.177L247.888 83.38 250.012 83.38 250.012 84.424 247.888 86.177"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFD",
    d: "M240.443 181.455h-1.098c.137-.525.268-1.055.392-1.585l.706 1.585"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M261.69 181.455h-11.678v-14.151l11.678 14.151m-13.802 0h-7.445l-.706-1.585c.647-2.768 1.112-5.596 1.388-8.475.206-2.14.303-4.282.292-6.413h6.471v16.473"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDFCFA",
    d: "M250.012 181.455L247.888 181.455 247.888 164.982 248.098 164.982 250.012 167.304 250.012 181.455"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFD",
    d: "M252.546 208.655L250.012 208.655 250.012 202.962 252.546 208.655"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M231.163 203.13c-.422-.45-.857-.886-1.31-1.3.45-.632.887-1.274 1.31-1.922v3.223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFD",
    d: "M247.888 208.655h-12.905c.05-.188.094-.374.138-.558-1.283-1.744-2.543-3.45-3.958-4.966v-3.223c1.62-2.471 3.059-5.052 4.31-7.725h9.743l2.672 6.006v10.466"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#at56hlmhom)",
    d: "M248.115 74.182c-.786 0-1.542-.439-1.907-1.194l-7.588-15.694c-1.041-2.155-3.169-3.636-5.551-3.866l-87.298-8.365c-2.39-.222-4.753.825-6.185 2.74l-10.43 13.968c-.7.937-2.028 1.13-2.963.43-.936-.698-1.129-2.026-.428-2.962l10.43-13.967c2.311-3.097 6.14-4.793 9.978-4.42l87.298 8.363c3.846.369 7.28 2.76 8.96 6.235l7.588 15.696c.51 1.051.067 2.317-.985 2.826-.296.143-.61.21-.919.21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M275.182 208.655h-22.636l-2.534-5.693v-10.78h20.53l7.542 9.145c-.439 1.145-.883 2.286-1.334 3.415-.507 1.313-1.03 2.62-1.568 3.913m-27.294-10.466l-2.672-6.006h2.672v6.006"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDFCFA",
    d: "M247.888 208.655L250.012 208.655 250.012 192.183 247.888 192.183z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E3DE",
    d: "M251.666 371.974c-.525 0-1.055-.026-1.585-.079l-65.695-6.295-10.95-64.73 1.15-.17 58.347-8.632.25-.036c1.216 1.034 2.447 2.227 3.688 3.59 10.003 10.986 20.569 32.927 27.232 70.479-.645.771-1.366 1.487-2.158 2.141-2.94 2.427-6.538 3.732-10.279 3.732M211.718 340.4l-7.961 26.89 14.96-24.594-2.558-17.293-1.621 5.48c-.721-5.52-5.17-10.01-10.945-10.565-.397-.038-.79-.055-1.18-.055-6.22 0-11.535 4.73-12.141 11.046-.642 6.715 4.277 12.678 10.99 13.322.398.038.79.055 1.182.055 3.664 0 7.016-1.642 9.274-4.286m23.003-17.042c-6.22 0-11.535 4.73-12.14 11.048-.643 6.712 4.277 12.676 10.99 13.32.396.038.789.057 1.178.057 6.219 0 11.538-4.73 12.142-11.046.644-6.715-4.277-12.68-10.99-13.322-.397-.038-.79-.057-1.18-.057"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFE1DD",
    d: "M203.757 367.289l7.961-26.89c1.574-1.84 2.617-4.166 2.865-6.76.09-.938.072-1.86-.045-2.758l1.621-5.479 2.558 17.293-14.96 24.594"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDECE8",
    d: "M264.637 240.533c-.282 0-.566-.022-.849-.05-.304-.026-.762-.084-.82-.1l-.872-.146c-.576-.107-1.17-.184-1.731-.317-3.627-.731-7.062-1.828-10.353-3.13-.714-.282-1.422-.573-2.124-.874l-.446-.19c-4.064-1.769-7.903-3.85-11.59-6.098-1.585-.97-3.15-1.966-4.689-2.99-1.2-.799-2.386-1.615-3.553-2.453 2.498-4.154 5.187-9.092 6.68-13.29 3.015 2.278 6.055 4.514 9.202 6.53 1.449.93 2.917 1.832 4.396 2.692.706.412 1.413.813 2.124 1.204 3.378 1.857 6.808 3.472 10.253 4.682 1.033.363 2.069.69 3.103.976.422.132.835.205 1.254.311l.096.025c.54-.446 1.306-1.247 1.955-2.156 1.946-2.663 3.782-6.074 5.41-9.558 1.087-2.257 2.118-4.581 3.1-6.946.536-1.293 1.06-2.6 1.567-3.913.451-1.13.895-2.27 1.334-3.415l4.161 5.04-1.775 18.52c-.953 2.345-2.067 4.705-3.511 7.098-1.328 2.069-2.722 4.276-5.698 6.436-1.141.787-2.708 1.6-4.607 1.943-.59.105-1.211.167-1.864.167-.051.002-.101.002-.153.002m-.191-13.01c-.258.072-.365.165-.32.165.01 0 .027-.005.051-.015.07-.025.16-.074.269-.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2E9E2",
    d: "M221.826 233.104s-4.981-7.211-8.608-15.143c1.802-1.204 3.554-2.505 5.248-3.903 4.376-3.611 8.19-7.722 11.387-12.229.453.415.888.85 1.31 1.302 1.415 1.516 2.675 3.222 3.958 4.966-.044.184-.088.37-.138.558-.184.714-.42 1.465-.694 2.24-1.492 4.198-4.181 9.136-6.679 13.29-.797 1.325-1.575 2.568-2.288 3.684-2 3.126-3.496 5.235-3.496 5.235"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#132529",
    d: "M195.754 17.353c-3.909-.735-7.445 1.893-7.882 5.876-.44 4 2.388 7.83 6.295 8.568 3.91.738 7.445-1.892 7.884-5.89.437-3.984-2.39-7.816-6.297-8.554M187.534.817L207.2 4.528c4.895.925 8.465 5.767 7.915 10.771l-3.805 34.632c-.05.462-.129.918-.258 1.336-1.124 4.24-5.21 6.908-9.653 6.07l-19.667-3.71c-4.443-.84-7.79-4.91-7.955-9.393-.034-.45-.012-.918.04-1.377l3.804-34.633c.551-5.006 5.016-8.33 9.914-7.407"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3769A4",
    d: "M71.199 103.022l-1.405-.134 2.193-22.9 1.406.135-2.194 22.9zm-1.873 19.555l-1.407-.134.97-10.113 1.406.134-.97 10.113zM178.246 103.663c-31.398 0-58.327 23.944-61.38 55.826-1.015 10.569.719 21.257 5.01 30.907 9.048 20.336 28.41 34.288 50.53 36.406 16.411 1.578 32.447-3.338 45.162-13.833 12.714-10.492 20.58-25.303 22.152-41.708.522-5.445.33-10.88-.568-16.158-2.727-16.212-12.05-30.925-25.58-40.365-4.243-2.971-8.83-5.381-13.635-7.163-5.014-1.886-10.314-3.107-15.759-3.628-1.99-.191-3.971-.284-5.932-.284m.162 124.84c-2.036 0-4.083-.099-6.137-.295-22.626-2.169-42.43-16.436-51.684-37.237-4.39-9.872-6.165-20.805-5.128-31.617 3.322-34.646 34.22-60.136 68.853-56.812 5.569.534 10.991 1.782 16.12 3.71 4.914 1.824 9.608 4.29 13.948 7.33 13.838 9.654 23.374 24.703 26.165 41.285.919 5.4 1.113 10.962.58 16.528-1.608 16.78-9.656 31.932-22.659 42.663-11.414 9.421-25.449 14.444-40.058 14.444M96.148 50.55c-3.747 0-7.355 1.297-10.3 3.729-3.354 2.766-5.43 6.656-5.84 10.953L53.988 336.805c-.412 4.296.884 8.508 3.652 11.862 2.767 3.353 6.657 5.427 10.953 5.839l181.489 17.389c4.302.422 8.51-.883 11.864-3.653 3.353-2.766 5.427-6.656 5.839-10.953l26.022-271.574c.411-4.296-.885-8.508-3.653-11.862-2.768-3.353-6.658-5.429-10.955-5.838L97.71 50.625c-.522-.051-1.044-.076-1.562-.076m155.498 322.833c-.565 0-1.131-.027-1.7-.08L68.459 355.91c-4.672-.447-8.901-2.7-11.908-6.345-3.006-3.644-4.416-8.225-3.968-12.896l26.02-271.572c.45-4.672 2.703-8.901 6.347-11.909 3.644-3.007 8.22-4.41 12.895-3.97l181.49 17.392c4.67.446 8.9 2.7 11.907 6.345 3.007 3.646 4.417 8.225 3.97 12.896l-26.023 271.572c-.447 4.672-2.7 8.902-6.346 11.909-3.2 2.64-7.123 4.05-11.196 4.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r8a6bc9iln)",
    d: "M124.835 53.224l5.06.484 4.93.474 23.723 2.272 23.556 28.545v17.37c-1.296-.08-2.58-.118-3.863-.118-22.139 0-42.114 11.65-53.406 29.575V53.224zm59.477 49.318c-.594-.057-1.188-.107-1.778-.146V85.52l16.763 20.317c-4.79-1.693-9.824-2.802-14.985-3.296z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5580B3",
    d: "M182.534 102.396c-.143-.01-.287-.02-.43-.028V85l.43.522v16.875"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prfdai757o)",
    d: "M120.387 191.38v-.865c.065.151.133.305.2.456l.08.179-.28.23m0-51.14V52.798l4.448.426v78.602c-1.682 2.672-3.172 5.483-4.448 8.414"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e6dk8vd2dp)",
    d: "M108.71 201.015V51.68l11.677 1.119v87.442c-2.577 5.923-4.28 12.344-4.928 19.114-1.02 10.645.683 21.407 4.928 31.16v.867l-11.676 9.634"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c8ocupwz8q)",
    d: "M63.416 238.388L80.01 65.231c.41-4.297 2.485-8.187 5.839-10.953 2.945-2.432 6.553-3.729 10.3-3.729.518 0 1.04.025 1.562.076l11 1.054v149.336l-45.294 37.373"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3769A4",
    d: "M62.645 239.025l16.66-173.861c.836-8.727 8.252-15.32 16.854-15.32.535 0 1.075.025 1.618.077l60.136 5.763.635.77-33.713-3.23-4.448-.426-22.677-2.173c-.522-.051-1.044-.076-1.562-.076-3.747 0-7.355 1.297-10.3 3.729-3.354 2.766-5.43 6.656-5.84 10.953L63.417 238.388l-.77.637m58.022-47.875l-.081-.179c-.067-.151-.135-.305-.2-.456-4.245-9.754-5.947-20.516-4.928-31.16.649-6.77 2.351-13.192 4.928-19.115 1.276-2.931 2.766-5.742 4.448-8.414 11.292-17.925 31.267-29.575 53.406-29.575 1.282 0 2.567.038 3.863.117.143.009.287.017.43.028.59.04 1.184.09 1.778.146 5.16.494 10.194 1.603 14.985 3.296l.886 1.075c-5.009-1.884-10.347-3.133-15.938-3.669-2.023-.194-4.037-.289-6.028-.289-31.792 0-58.96 24.173-62.056 56.467-1.062 11.082.849 21.77 5.071 31.262l-.564.466"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#84c8j2gc5r)",
    d: "M284.617 181.603l-1.658 17.305-.714 7.459-4.16-5.04-7.544-9.144-8.851-10.728-11.678-14.151-1.914-2.322-.21-.253-7.152-8.67c-.06-.397-.124-.795-.191-1.192l-.107-.611c-1.024-5.734-2.856-11.28-5.393-16.476-1.847-3.782-4.068-7.377-6.624-10.726-.356-.466-.718-.926-1.086-1.382-3.669-4.54-7.969-8.588-12.794-11.979l16.772-13.84 5.543-4.572 11.032-9.104 2.124-1.753 1.267-1.044 13-10.728.2-.164 6.39-5.272 8.33.799c3.759.358 7.205 1.99 9.863 4.637.38.38.745.78 1.091 1.201 2.264 2.743 3.543 6.06 3.71 9.527.036.772.017 1.552-.057 2.335l-1.355 14.138-1.028 10.728-1.578 16.473-.193 2.008-.835 8.718-1.578 16.476-1.03 10.726-1.213 12.676-.379 3.945z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3769A4",
    d: "M282.88 207.136l-.635-.769 11.56-120.652c.075-.783.094-1.563.058-2.335-.167-3.467-1.446-6.784-3.71-9.527-.346-.421-.71-.82-1.091-1.201-2.658-2.648-6.104-4.28-9.864-4.637l-8.33-.8.77-.634 7.629.731c9.27.888 16.13 9.201 15.241 18.47L282.88 207.137m-42.144-51.076l-.887-1.074c-2.81-16.701-12.306-31.36-25.872-40.826l.564-.467c4.825 3.391 9.125 7.438 12.794 11.98.368.455.73.915 1.086 1.381 2.556 3.349 4.777 6.944 6.624 10.726 2.537 5.195 4.369 10.742 5.393 16.476l.107.61c.067.398.13.796.19 1.194"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fp5736jvvs)",
    d: "M271.638 66.58l-57.661 47.58c-4.226-2.958-8.853-5.414-13.794-7.247l-42.27-51.229 113.725 10.897"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69C4A6",
    d: "M234.721 323.357c.39 0 .783.02 1.18.057 6.713.642 11.634 6.607 10.99 13.322-.604 6.316-5.923 11.046-12.142 11.046-.39 0-.782-.02-1.178-.057-6.713-.644-11.633-6.608-10.99-13.32.605-6.317 5.92-11.048 12.14-11.048zm-32.308-3.095c.39 0 .783.017 1.18.055 5.776.555 10.224 5.046 10.945 10.564l-2.82 9.518c-2.258 2.644-5.61 4.286-9.274 4.286-.391 0-.784-.017-1.181-.055-6.714-.644-11.633-6.607-10.991-13.322.606-6.315 5.921-11.046 12.14-11.046zM80.119 328.56l28.592 2.74 11.676 1.12 4.448.426 17.882 1.713-.425 4.42-17.457-1.67-4.448-.428-11.676-1.119-29.016-2.78.424-4.422zm34.042-6.773l6.226.597 4.448.425 11.1 1.064-.424 4.42-10.676-1.022-4.448-.427-6.65-.637.424-4.42zm-33.089-3.171l27.002 2.587-.423 4.422-27.002-2.589.423-4.42zm.954-9.945l26.685 2.557 11.676 1.119 4.448.425 30.62 2.935-.423 4.42-30.197-2.893-4.448-.426-11.676-1.119-27.11-2.597.425-4.42zm40.406-42.14c.105 0 .212.004.319.015l3.363.322 38.408 3.68 49.09 4.705c1.804.172 3.126 1.774 2.954 3.578l-.542 5.641c-.162 1.697-1.591 2.97-3.26 2.97-.106 0-.213-.006-.32-.016l-44.394-4.253-43.215-4.142-3.252-.312c-.43-.041-.834-.163-1.196-.35-1.153-.6-1.888-1.855-1.756-3.228l.391-4.089.15-1.554c.162-1.697 1.59-2.968 3.26-2.968zm-6.33-22.707c.106 0 .212.005.317.015l3.968.38 4.448.426 3.935.377 17.92 1.718 12.235 1.172 65.213 6.248c1.312.124 2.369 1.006 2.782 2.171.155.437.218.914.172 1.406l-.002.013-.539 5.63c-.163 1.7-1.592 2.97-3.263 2.97-.105 0-.21-.006-.315-.016l-61.063-5.85-26.342-2.524-17.455-1.674-2.86-.273c-1.803-.174-3.125-1.775-2.953-3.58l.542-5.642c.162-1.697 1.59-2.967 3.26-2.967z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#132529",
    d: "M192.74 16.666c3.958.721 6.598 4.542 5.884 8.533-.718 4.004-4.52 6.651-8.478 5.93-3.957-.721-6.598-4.543-5.88-8.549.714-3.99 4.517-6.637 8.474-5.914M205.332 3.78L185.419.147c-4.957-.903-9.758 2.443-10.657 7.456l-6.22 34.684c-.082.461-.137.93-.132 1.379-.13 4.486 3.026 8.546 7.526 9.367l19.913 3.63c4.5.822 8.868-1.869 10.304-6.117.16-.42.272-.876.355-1.338l6.22-34.682c.898-5.013-2.438-9.844-7.396-10.746"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#9hic7l4h5t)",
    d: "M197.47 56.812c-.535 0-1.077-.048-1.621-.148l-13.315-2.427-.43-.08-6.168-1.124c-4.412-.804-7.533-4.723-7.53-9.106 0-.088 0-.175.004-.261v-.064c0-.43.053-.875.133-1.315l6.219-34.684c.8-4.462 4.69-7.602 9.032-7.602.537 0 1.081.048 1.625.146l19.913 3.633c4.415.803 7.545 4.723 7.541 9.112 0 .54-.048 1.085-.146 1.634l-6.22 34.682c-.082.462-.194.918-.354 1.338-.034.098-.069.196-.105.293-1.238 3.287-4.252 5.58-7.676 5.926-.297.031-.599.047-.902.047m-13.323-32.904c.005 3.49 2.482 6.58 5.999 7.22.439.082.874.12 1.305.12 3.456 0 6.534-2.488 7.173-6.05.077-.437.115-.87.117-1.299.005-3.49-2.475-6.591-6-7.233-.44-.081-.877-.119-1.31-.119-3.454 0-6.53 2.486-7.165 6.033-.081.446-.119.89-.119 1.328"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#527CB1",
    d: "M211.718 340.399l2.82-9.518c.117.897.136 1.82.045 2.758-.248 2.594-1.291 4.92-2.865 6.76"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteProfileArt);
export default __webpack_public_path__ + "static/media/complete-profile-art.ed15f824d9656216ec2058721d8e9a65.svg";
export { ForwardRef as ReactComponent };